import { useUserStore } from '@common/modules/user/stores'

/**
 * Reads lastUsedWorkspaceId from the current user's regional identity in the user store.
 */
export function getLastUsedWorkspaceIdFromUserStore(): string | null {
  return useUserStore.getState().currentUser?.regionalIdentity?.lastUsedWorkspaceId ?? null
}
